// import { formatCurrency as format } from "@nosto/preact";

// export function formatCurrency(value, currency = window.Shopify?.currency?.active || defaultConfig.currency) {
//     return format(value, currency)
// }

import { defaultConfig } from "./config"

export function formatCurrency(value, currency = window.Shopify?.currency?.active || defaultConfig.currency) {
    const formats = {
        ALL: () => {
            return `Lek ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        DZD: () => {
            return `DA ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        AOA: () => {
            return `Kz ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        XCD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        ARS: () => {
            return `$${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        AMD: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} AMD`
        },
        AWG: () => {
            return `Afl${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        AUD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        AZN: () => {
            return `m.${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BSD: () => {
            return `BS$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BDT: () => {
            return `Tk ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BBD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BZD: () => {
            return `BZ$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        EUR: () => {
            return `€${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        USD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        XOF: () => {
            return `$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BOB: () => {
            return `Bs${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BAM: () => {
            return `KM ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BWP: () => {
            return `P${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BRL: () => {
            return `R$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BND: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        BGN: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} лв`
        },
        KHR: () => {
            return `KHR${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        XAF: () => {
            return `$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CAD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CVE: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value).replaceAll('.', ' ')}$`
        },
        KYD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CLP: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        COP: () => {
            return `$${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        KMF: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} CF`
        },
        NZD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CRC: () => {
            return `₡ ${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        ANG: () => {
            return `€${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CZK: () => {
            return `Kč${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        DKK: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} kr`
        },
        DJF: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} Fdj`
        },
        DOP: () => {
            return `RD$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        EGP: () => {
            return `LE ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        SZL: () => {
            return `L ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        ETB: () => {
            return `Br${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        FKP: () => {
            return `£${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        FJD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        XPF: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value).replaceAll(',', ' ')} XPF`
        },
        GMD: () => {
            return `D ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        GEL: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} GEL`
        },
        GBP: () => {
            return `£${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        GTQ: () => {
            return `Q ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        GNF: () => {
            return `FG ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        GYD: () => {
            return `G$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        HTG: () => {
            return `G ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        HNL: () => {
            return `L ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        HKD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        HUF: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} Ft`
        },
        ISK: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} kr`
        },
        INR: () => {
            return `Rs. ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        IDR: () => {
            return `Rp ${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        ILS: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} NIS`
        },
        JMD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        JPY: () => {
            return `¥${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        JPY: () => {
            return `¥${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        KZT: () => {
            return `₸${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        KES: () => {
            return `KSh${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        KGS: () => {
            return `лв${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        LAK: () => {
            return `₭${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        LBP: () => {
            return `L£${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        LSL: () => {
            return `M${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CHF: () => {
            return `CHF ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MOP: () => {
            return `MOP$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MWK: () => {
            return `Mk${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MVR: () => {
            return `Rf${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MUR: () => {
            return `Rs ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MXN: () => {
            return `$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MUR: () => {
            return `Rs ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MNT: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)} ₮`
        },
        MAD: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} dh`
        },
        MZN: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} Mt`
        },
        NPR: () => {
            return `Rs${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        NIO: () => {
            return `C$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        NGN: () => {
            return `₦${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        MDK: () => {
            return `ден ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        NOK: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} kr`
        },
        PKR: () => {
            return `Rs.${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        PGK: () => {
            return `K ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        PYG: () => {
            return `Gs. ${new Intl.NumberFormat("de-DE", {
                currency,
            }).format(value)}`
        },
        PEN: () => {
            return `S/. ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        PHP: () => {
            return `₱${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        PLN: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} zł`
        },
        QAR: () => {
            return `QAR ${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        RON: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} lei`
        },
        RWF: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)} RF`
        },
        WST: () => {
            return `WS$ ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        STD: () => {
            return `Db ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        SAR: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} SR`
        },
        RSD: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} RSD`
        },
        SCR: () => {
            return `Rs ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        SLL: () => {
            return `Le ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        SGD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        ZAR: () => {
            return `R ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        KRW: () => {
            return `₩${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)}`
        },
        LKR: () => {
            return `Rs ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        SEK: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)} kr`
        },
        TRY: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}TL`
        },
        TWD: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        TZS: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} TZS`
        },
        THB: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} ฿`
        },
        UGX: () => {
            return `Ush ${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)}`
        },
        AED: () => {
            return `AED ${new Intl.NumberFormat("en-US", {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        UZS: () => {
            return `${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value).replaceAll(',', ' ')} som`
        },
        VUV: () => {
            return `$${new Intl.NumberFormat("en-US", {
                currency,
            }).format(value)}`
        },
        VND: () => {
            return `${new Intl.NumberFormat("de-DE", {
                currency,
            }).format(value)}₫`
        },
        ZMW: () => {
            return `K${new Intl.NumberFormat("de-DE", {
                currency,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `$${value}`
}